// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  // Use ultra-high-quality image source for zoom - try multiple size patterns
  let imageSrc = image.src;
  
  // Try progressively larger sizes for maximum zoom quality
  const largePatterns = [
    { suffix: '_6000x6000', priority: 1 },
    { suffix: '_5000x5000', priority: 2 },
    { suffix: '_4000x4000', priority: 3 },
    { suffix: '_3000x3000', priority: 4 },
    { suffix: '_2048x2048', priority: 5 }
  ];
  
  // Remove existing size suffix and add largest available
  for (const pattern of largePatterns) {
    const testSrc = image.src.replace(/(\._thumb|_small|_compact|_medium|_large|_grande|\+\d+x\d+)(\.(jpg|jpeg|png|webp))?/, `${pattern.suffix}.webp`);
    if (testSrc !== image.src) {
      imageSrc = testSrc;
      break;
    } else {
      const testSrcJpg = image.src.replace(/(\._thumb|_small|_compact|_medium|_large|_grande|\+\d+x\d+)(\.(jpg|jpeg|png|webp))?/, `${pattern.suffix}.jpg`);
      if (testSrcJpg !== image.src) {
        imageSrc = testSrcJpg;
        break;
      }
    }
  }
  
  overlayImage.setAttribute('src', imageSrc);
  overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  
  // Use same ultra-high-quality background image logic
  let bgImageSrc = image.src;
  
  // Try progressively larger sizes for background
  const largePatterns = [
    { suffix: '_6000x6000', priority: 1 },
    { suffix: '_5000x5000', priority: 2 },
    { suffix: '_4000x4000', priority: 3 },
    { suffix: '_3000x3000', priority: 4 },
    { suffix: '_2048x2048', priority: 5 }
  ];
  
  // Remove existing size suffix and add largest available
  for (const pattern of largePatterns) {
    const testSrc = image.src.replace(/(\._thumb|_small|_compact|_medium|_large|_grande|\+\d+x\d+)(\.(jpg|jpeg|png|webp))?/, `${pattern.suffix}.webp`);
    if (testSrc !== image.src) {
      bgImageSrc = testSrc;
      break;
    } else {
      const testSrcJpg = image.src.replace(/(\._thumb|_small|_compact|_medium|_large|_grande|\+\d+x\d+)(\.(jpg|jpeg|png|webp))?/, `${pattern.suffix}.jpg`);
      if (testSrcJpg !== image.src) {
        bgImageSrc = testSrcJpg;
        break;
      }
    }
  }
  
  container.style.backgroundImage = `url('${bgImageSrc}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
  container.style.backgroundRepeat = 'no-repeat';
  container.style.backgroundPosition = 'center';
  container.style.backgroundSize = 'contain';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame with proper sizing
  const zoomWidth = image.width * zoomRatio;
  const zoomHeight = image.height * zoomRatio;
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${zoomWidth}px ${zoomHeight}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => overlay.remove();
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => overlay.remove();
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });
}

enableZoomOnHover(2);
